import { render } from "./TheSpotlight.vue?vue&type=template&id=65561785&scoped=true&ts=true"
import script from "./TheSpotlight.vue?vue&type=script&lang=ts"
export * from "./TheSpotlight.vue?vue&type=script&lang=ts"

import "./TheSpotlight.vue?vue&type=style&index=0&id=65561785&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65561785"]])

export default __exports__